import React from "react";
import { useHistory, useLocation } from "react-router";
import { useFormContext } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  Subscription,
  SubscriptionDetails,
  SubscriptionPriceMode,
} from "store/subscriptions/types";
import { SUBSCRIPTION_PERIOD, SUBSCRIPTION_PERIOD_MONTHS } from "./utils";
import Toggle from "components/Switch/Toggle";
import { formatPrice } from "utils/formatPrice";

export const NewSubscriptionPlanInfo = ({
  promocode,
  priceMode,
}: {
  promocode: string;
  priceMode?: SubscriptionPriceMode;
}) => {
  const subscriptions: Subscription[] = useAppSelector(
    (state) => state.subscriptions.all,
  );
  const subscriptionDetails: SubscriptionDetails = useAppSelector(
    (state) => state.subscriptions.selectedSubscription,
  );

  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();

  const { setValue, watch } = useFormContext();

  const selectedIndex = watch("subscriptionIndex") || 0;
  const selected = subscriptions[selectedIndex];

  const monthly = subscriptions.find((s) => s.period === "month");
  const yearly = subscriptions.find((s) => s.period === "year");

  const isYearly = selected?.period === "year";

  if (!monthly || !yearly) return null;

  const monthlyPrice = monthly.price;
  const selectedPlanName = `${SUBSCRIPTION_PERIOD[selected?.period] ||
    selected?.name ||
    "Monthly"} Plan`;

  const handleToggle = (checked: boolean) => {
    const target = checked ? yearly : monthly;

    const index = subscriptions.findIndex((s) => s._id === target._id);

    setValue("subscriptionIndex", index);

    const params = new URLSearchParams({
      subscriptionType: target.lookupKey,
    });

    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });

    dispatch({
      type: "GET_SUBSCRIPTION",
      crossSellsIds: [],
      id: target._id,
      promocode,
      priceMode,
    });
  };

  const yearlyFullPrice = monthlyPrice * SUBSCRIPTION_PERIOD_MONTHS.year;

  const savingsPercent = Math.round(
    ((yearlyFullPrice - yearly.price) / yearlyFullPrice) * 100,
  );
  const trialDays = subscriptionDetails?.membership?.trialDays || 0;

  const selectedPlan = isYearly ? yearly : monthly;
  const billingPeriod = isYearly ? "yearly" : "mo";
  const billingLabel = ` /${billingPeriod}${trialDays ? " after" : ""}`;

  return (
    <>
      <div className="cart-summary-item">
        <div className="cart-summary-item__left">
          <span>{selectedPlanName}</span>
        </div>
        <div className="cart-summary-item__end-column">
          {!!trialDays && (
            <p className="signup-wrapper__left__info-right">{`${trialDays} days free`}</p>
          )}
          <p className="signup-wrapper__left__info-right">
            {formatPrice(selectedPlan.price)}
            <span>{billingLabel}</span>
          </p>
        </div>
      </div>
      <div className="divider" />
      <div className="subscription-ui">
        <Toggle checked={isYearly} onChange={handleToggle} />

        {savingsPercent > 0 && (
          <span className="subscription-ui__save">
            <p className="subscription-ui__save-text">SAVE {savingsPercent}%</p>
          </span>
        )}
        <p className="subscription-ui__subtitle">with annual</p>
      </div>
    </>
  );
};
